import React from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import Typography from "@mui/material/Typography";

// 아이디 , 비밀번호 TextField
export const IconTextField = ({
  inputRef = null,
  placeholder = "아이디",
  value = "",
  onKeyDown,
  onChange,
  inputCase = "text",
  icon,
}) => {
  return (
    <TextField
      placeholder={placeholder}
      size="small"
      inputRef={inputRef}
      value={value}
      onKeyDown={onKeyDown}
      type={inputCase}
      onChange={(e) => onChange(e)}
      sx={{
        backgroundColor: "#fff",
        width: "100%",
        fontSize: "16px",
        color: "grey.600",
        "& label.Mui-focused": {
          color: "grey.900",
        },
        "& input": {
          color: "grey.600",
          pl: 1,
          pt: 1.75,
          pb: 1.625,
          fontSize: "16px",

          "&:focus": {
            color: "grey.900",
          },
        },
        "& .MuiInput-underline:after": {
          borderColor: "grey.400",
        },
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: "grey.400",
          },
          "&:hover fieldset": {
            borderColor: "grey.400",
          },
          "&.Mui-focused fieldset": {
            borderColor: "grey.400",
          },
          "& .icon_arrow": {
            fill: "#DDDDDF",
          },
          "&.Mui-focused": {
            "& .MuiInputAdornment-root": {
              borderColor: "red",
              "& .icon_arrow": {
                fill: "#000000",
              },
            },
          },
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">{icon}</InputAdornment>
        ),
      }}
    />
  );
};

// 아이디 , 비밀번호 TextField
export const IconTextField01 = ({
  inputRef = null,
  placeholder = "아이디",
  onKeyDown,
  inputCase = "text",
  icon,
}) => {
  return (
    <TextField
      placeholder={placeholder}
      size="small"
      inputRef={inputRef}
      onKeyDown={onKeyDown}
      type={inputCase}
      sx={{
        backgroundColor: "#fff",
        width: "100%",
        fontSize: "16px",
        color: "grey.600",
        "& label.Mui-focused": {
          color: "grey.900",
        },
        "& input": {
          color: "grey.600",
          pl: 1,
          pt: 1.75,
          pb: 1.625,
          fontSize: "16px",

          "&:focus": {
            color: "grey.900",
          },
        },
        "& .MuiInput-underline:after": {
          borderColor: "grey.400",
        },
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: "grey.400",
          },
          "&:hover fieldset": {
            borderColor: "grey.400",
          },
          "&.Mui-focused fieldset": {
            borderColor: "grey.400",
          },
          "& .icon_arrow": {
            fill: "#DDDDDF",
          },
          "&.Mui-focused": {
            "& .MuiInputAdornment-root": {
              borderColor: "red",
              "& .icon_arrow": {
                fill: "#000000",
              },
            },
          },
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">{icon}</InputAdornment>
        ),
      }}
    />
  );
};

export const OutlinedInputDefault = ({
  name,
  krName = "",
  value,
  inputType = "text",
  onChange,
  disabled = false,
  multiline = false,
  minRows = 1,
  maxRows,
}) => {
  return (
    <OutlinedInput
      id={`outline_${name}`}
      autoComplete={"new-password"}
      disabled={disabled}
      value={value}
      type={inputType}
      onChange={onChange}
      multiline={multiline}
      minRows={minRows}
      maxRows={maxRows}
      sx={{ height: multiline ? "auto" : 41, minHeight: 41, m: 0, fontSize: 12 }}
      fullWidth
      inputProps={{
        "aria-label": { krName },
      }}
    />
  );
};

export const OutlinedInputRightAdornment = ({
  name,
  adorment = "",
  krName = "",
  value,
  onChange,
  disabled = false,
}) => {
  return (
    <OutlinedInput
      id={`outline_${name}`}
      value={value}
      onChange={onChange}
      sx={{
        height: 41,
        m: 0,
        fontSize: 12,
        backgroundColor: "white",
      }}
      disabled={disabled}
      fullWidth
      endAdornment={
        <InputAdornment position="end">
          <Typography
            variant="body2"
            color="#9A9A9B"
            align="left"
            fontWeight={500}
          >
            {adorment}
          </Typography>
        </InputAdornment>
      }
      inputProps={{
        "aria-label": { krName },
      }}
    />
  );
};
